/**
 * Created by mauget on 3/2/16.
 */

// UserDetails.js

import $ from 'jquery';
import _ from 'lodash';

import {Model} from 'backbone';
import BasePropertyView from 'BasePropertyView.js';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/settings/user-details-view.ejs';
import CountryList from 'CountryList.js';
import USStates from 'USStates.js';
import CAProvinces from 'CAStates.js';
import RestService from 'RestService';
import NotificationService from 'NotificationService';
import SelectFormOrReportModal from 'common-views/SelectFormOrReportModalView.js';
import eventBus from 'EventBus.js';
import userService      from 'UserService.js';
import undoService from 'UndoService'
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import textConstants from 'TextConstants';
import util from 'util/Util';
import listService from 'ListService.js';

class UserDetailsView extends BasePropertyView {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;

        this.events = {
            'keyup input': 'updateButtonActions',
            'change input[type=text]': 'updateTextInputs',
            'change input[name=IsActive]': 'updateCheckboxes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'  : 'getFocus',
            'click input[name=applyChanges]': 'applyChanges',
            'click input[name=delete]': 'promptDeleteUser',
            'change input[type=radio]': 'updateRoleSelection',
            'change input[type=checkbox]': 'updateButtonActions',
            'click input[name=selectReport]': 'chooseReport',
            'click input[name=clearReport]': 'clearReport',
            'change input[name=HasOfflineRight]': 'changeOfflineStatus',
            'change select[name=Title],select[name=LanguageISO],select[name=StateProvince]': 'changeDropdownValue',
            'change select[name=CountryISO]': 'processCountrySelection',
            'click input[name=cancel]': 'cancelChanges',
            'click input[name=sendPasswordLink]': 'sendPasswordLink',
            'click input[name=unblock]': 'unblock',
            'click #goToSettings': 'goToSettings',
            'click #goToAccountSettings': 'goToAccountSettings', 
            'click #goToUsersInfo': 'goToUsersInfo',
            'click input[name=sendAPIKey]': 'sendAPIKey'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    promptDeleteUser() {
        console.log('=== DELETING USER ===')
        let simpleModal=new SimpleConfirmModalView({
            model:new Model({subtitle:"Delete User",
                confirmationText:`Are you sure you want to delete the selected user?`,
                height: 'auto',
                width:400})
        });
        simpleModal.render().then((result)=>{
            if (result === 'Ok') {
                const userDetails = this.model.get('userDetails');
                const userId = userDetails.UserId;
                this.deleteUser(userDetails.UserId).then(()=>{
                    undoService.add({
                        redo: ()=>{
                            this.deleteUser(userId)
                        },
                        undo: ()=>{
                            this.unDeleteUser(userId)
                        }
                    },textConstants.UNDO_DELETE_USER)
                })
            }
        }).catch((err)=> {
            console.log('Error Showing Delete List Confirmation Message', err);
        });
    }

    deleteUser(userId){
        return RestService.deleteUser(userId).then(function(){
            return eventBus.trigger(constants.EV_DELETE_USER,userId);
        });

    }

    unDeleteUser(userId){

        return RestService.unDeleteUser(userId).then(function(data){
            let fullName=`${data.FirstName || ""} ${data.LastName || ""}`;
            if(listService.activeDashboardTab === 'settings') {
                eventBus.trigger(constants.EV_OPEN_UNDELETED_USER_DETAILS, userId);
            }
                NotificationService.success(`User ${fullName} was restored`);

            return (data);
        });
    }

    cancelChanges() {
        let userDetails = this.model.get('userDetails');
        this.model.set('updatedUserDetails', Object.assign({}, userDetails), {silent: true});
        this.model.set('hasChanges', false,{silent:true});
        this.render();
    }

    updateButtonActions() {
        console.log('entered Update button');
        $("#noChangesSection").addClass('hide');
        $("#changesSection").removeClass('hide');
    }

    changeDropdownValue(ev) {
        this.updateButtonActions();
        let userDetails = this.model.get('updatedUserDetails');
        userDetails[event.target.name] = ev.target.value.toLowerCase();
        this.model.set('updatedUserDetails', userDetails, {silent: true});
        this.model.set('hasChanges', true,{silent:true});
    }

    processCountrySelection(event) {
        this.updateButtonActions();
        let userDetails = this.model.get('updatedUserDetails');
        let stateProvinceDropdown = $(`select[name='StateProvince']`);
        switch (event.target.value) {
            case 'US':
                let usStateOptions = USStates.getStatesList().map((state)=> {
                    return $(`<option value='${state.value}'>${state.caption}</option>`);
                });
                stateProvinceDropdown.prop('disabled', false);
                stateProvinceDropdown.empty();
                stateProvinceDropdown.append(usStateOptions);
                break;
            case 'CA':
                let caProvinceOptions = CAProvinces.getProvincesList().map((province)=> {
                    return $(`<option value='${province.value}'>${province.caption}</option>`);
                });
                stateProvinceDropdown.prop('disabled', false);
                stateProvinceDropdown.empty();
                stateProvinceDropdown.append(caProvinceOptions);
                break;
            default:
                stateProvinceDropdown.empty();
                stateProvinceDropdown.prop('disabled', true);
                userDetails.StateProvince = '';
        }
        userDetails[event.target.name] = event.target.value.toLowerCase();
        this.model.set('updatedUserDetails', userDetails, {silent: true});
        this.model.set('hasChanges', true,{silent:true});
    }

    updateCheckboxes(ev) {
        ev.preventDefault();
        const currentModel = this.model.get('updatedUserDetails');
        const propName = ev.currentTarget.name;
        currentModel[propName] = ev.currentTarget.checked === true ? "True" : "False";
        this.model.set('updatedUserDetails', currentModel, {silent: true});
        this.model.set('hasChanges', true, {silent: true});
    }


    updateTextInputs(ev) {
        let prop = ev.target.name;
        let value = ev.target.value;
        let userDetails = this.model.get('updatedUserDetails');
        console.log('UserDetails Before Update', userDetails);
        userDetails[prop] = value;
        this.model.set('updatedUserDetails', userDetails, {silent: true});
        this.model.set('hasChanges', true,{silent:true});
        console.log('UserDetails After Update', this.model.get('updatedUserDetails'));
    }

    changeOfflineStatus(ev) {
        let userDetails = this.model.get('updatedUserDetails');
        userDetails.HasOfflineRight = ev.target.checked ? "True" : "False";
        this.model.set('updatedUserDetails', userDetails, {silent: true});
        this.model.set('hasChanges', true,{silent:true});
    }

    chooseReport(ev) {
        ev.preventDefault();
        let userDetails = this.model.get('updatedUserDetails');
        var sfModal = new SelectFormOrReportModal({model: new Model(), mode: 'report'});
        sfModal.render().then((selectedFormOrReport)=> {
            console.log('Coming Report', selectedFormOrReport);
            this.updateButtonActions();
            userDetails.HomeReportId = selectedFormOrReport.id;
            userDetails.HomeReportName = selectedFormOrReport.name;
            this.model.set('hasChanges', true,{silent:true});
            this.model.set('updatedUserDetails', userDetails, {silent: true});
            console.log('weird model', this.model);
            $('input[name="searchReport"]').val(selectedFormOrReport.name);
        }).catch(err => console.log(err));
    }

    clearReport(ev) {
        ev.preventDefault();
        let userDetails = this.model.get('updatedUserDetails');
        this.updateButtonActions();
        userDetails.HomeReportName = '';
        userDetails.HomeReportId = '';
        this.model.set('hasChanges', true,{silent:true});
        this.model.set('updatedUserDetails', userDetails, {silent: true});
        $('input[name="searchReport"]').val('');
    }

    updateRoleSelection(ev) {
        this.updateButtonActions();
        this.disableUnrequiredRoleOptions(ev.target.value);
    }

    disableUnrequiredRoleOptions(selectedRoleOption) {
        let basicUser = $('.basicUser');
        let fullUser = $('.fullUser');
        basicUser.prop('disabled', true);
        fullUser.prop('disabled', true);

        switch (selectedRoleOption) {
            case '2':
                fullUser.prop('disabled', false);
                break;
            case '1':
                basicUser.prop('disabled', false);
                break;
        }
    }

    applyChanges() {
        
        this.updateRoleState();
        this.makeUpdate();
    }

    updateTreeview(){
        eventBus.trigger(constants.UPDATE_USER_TREEVIEW);
    }

    makeUpdate(){
        const newDetails = Object.assign({}, this.model.get('updatedUserDetails'))
        const oldDetails = Object.assign({}, this.model.get('userDetails'))

        undoService.add({
            undo: ()=> {
                this.persistData(oldDetails)
            },
            redo: () => {
                this.persistData(newDetails)
            }
        }, textConstants.UNDO_UPDATE_USER);


        this.persistData(newDetails);
        util.setUndoRedoAccess();
    }

    persistData(updatedModel){

        console.log('Updated Model Before Sent', updatedModel);
        RestService.updateUser(updatedModel).then((returnValue)=> {
            if (returnValue.RESULT.ERROR.CODE !== '0') {
                throw new Error('Update to User Details Failed.Error Message:', returnValue.RESULT.ERROR.RESPONSE);
            }
            if (listService.activeDashboardTab === 'settings'){
              this.refreshUserData(updatedModel);
            }
        }).catch((error)=> {
            const msg = error.MESSAGE || error;
            NotificationService.error('An error has occurred. ' + msg);
        });
    }

    refreshUserData(updatedModel){
        RestService.getUserDetails(updatedModel.UserId).then((userDetails)=> {
            console.log('Updated User Details', userDetails);

            var breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', route: '#settings', id: 'goToAccountSettings'},
                {name: 'General User Information', route: '#settings', id: 'goToUsersInfo'}, 
                {name: 'User Details', id: undefined}]; 

            this.model.set('dashboardTitle', 'Users', {silent: true});
            this.model.set('breadcrumbs', breadcrumbs, {silent: true});

            this.model.set('userDetails', userDetails, {silent: true});
            this.model.set('updatedUserDetails', Object.assign({}, userDetails), {silent: true});
            this.render();

            this.updateTreeview();
        });
    }

    updateRoleState(){
        console.log('I have been clicked');
        // Update Roles
        let currentModel = this.model.get('updatedUserDetails');
        switch ($('input[name="Status"]:checked').val()) {
            case '2':
                let roleNumber = this.getRoleNumber();
                currentModel.HomeReportId = '';
                currentModel.HomeReportName = '';
                currentModel.Roles = roleNumber;
                currentModel.Status = '2';
                break;
            case '1':
                //let chosenReport = this.model.get('chosenReport');
                currentModel.Roles = '0';
                //currentModel.HomeReportId = chosenReport.id;
                //currentModel.HomeReportName = chosenReport.name;
                currentModel.Status = '1';
                break;
            default:
                currentModel.Status = '3';
                currentModel.Roles = '0';
                currentModel.HomeReportId = '';
                currentModel.HomeReportName = '';
                break;
        }
        this.model.set('hasChanges', true,{silent:true});
        this.model.set('updatedUserDetails', currentModel, {silent: true});
    }

    getRoleNumber() {
        let rolePermissions = $(".fullUser:checked").toArray();
        console.log("Role Permissions", rolePermissions);
        let sumPermissions = rolePermissions.reduce((accum, elem) => {
            return accum + parseInt(elem.value);
        }, 0);
        console.log('Sum', sumPermissions);
        //At least Users and Account must be always selected 
        return sumPermissions===0 ? 24 : sumPermissions;
    }

    updateRoles(userDetails){
        // Checking the roles Full User.
        switch (userDetails.Status) {
            case "2":
                // Decoding the Roles Property into checkbox Permissions.
                let userPermissions = userService.getUserPermissionsByRoleNumber(userDetails.Roles);                          
                $("#sendAPIKey").prop("disabled", userPermissions.api && listService.accountAPIEnabled && listService.accountAPIEnabled.toLowerCase() === 'true' ? false :true); 
                $.each(userPermissions, function (property, value) {                    
                    $(`input:checkbox[name="${property}"]`).prop('checked', value);                                   
                });
                break;
            // Basic User.
            case "1" :
            case "3" :
                break;
        }

        // Selecting the radio button for the Status property and disabling the others.
        $(`input:radio[value="${userDetails.Status}"]`).prop('selected', true);
        this.disableUnrequiredRoleOptions(userDetails.Status);
    }

    updateInputs(userDetails){
        $(`option[value="${userDetails.Title}"]`).prop('selected', true);
        $(`input[name="IsActive"]`).prop('checked', userDetails.IsActive === 'True');
        $(`input[name="Status"][value='${userDetails.Status}']`).prop('checked', true);
        $(`input[name="HasOfflineRight"]`).prop('checked', userDetails.HasOfflineRight === 'True');
    }

    updateDropdowns(userDetails){
        this.fillCountries();
        if (userDetails.CountryISO) {
            if (userDetails.CountryISO === 'us') {
                this.fillUSStates();
            }
            else if (userDetails.CountryISO === 'ca') {
                this.fillCanadianProvinces();
            }
            else {
                // If not Canada or EU is chosen, disable state dropdown.
                $(`select[name="StateProvince"]`).prop('disabled', true);
            }
            // If there is an State/Province on the model select it.
            if (userDetails.StateProvince) {
                $(`select[name="StateProvince"] option[value='${userDetails.StateProvince.toUpperCase()}']`).prop('selected', true);
            }
            // Selecting the Country from the model.
            $(`select[name="CountryISO"] option[value='${userDetails.CountryISO.toUpperCase()}']`).prop('selected', true);
        }
    }

    fillCountries(){
        let countryOptions = CountryList.getCountryList().map((country)=> {
            return $(`<option value='${country.value}'>${country.caption}</option>`);
        });
        $('select[name="CountryISO"]').append(countryOptions);
    }

    fillUSStates(){
        let usStateOptions = USStates.getStatesList().map((state)=> {
            return $(`<option value='${state.value}'>${state.caption}</option>`);
        });
        $('select[name="StateProvince"]').append(usStateOptions);
    }

    fillCanadianProvinces(){
        let caProvinceOptions = CAProvinces.getProvincesList().map((province)=> {
            return $(`<option value='${province.value}'>${province.caption}</option>`);
        });
        $('select[name="StateProvince"]').append(caProvinceOptions);
    }
    
    sendPasswordLink(){
        const userDetails=this.model.get('updatedUserDetails');
        console.log("userDetails",userDetails);
        RestService.sendPasswordLink(userDetails.UserId).then((result)=>{
            NotificationService.success(`The email message with the password-link has been sent to the user's email address.`)
        }).catch((error) => {
            console.log(error);
            let msg = error || 'Error while sending temporary user password';
            NotificationService.error(msg);
        });

    }

    sendAPIKey(){
        const userDetails=this.model.get('updatedUserDetails');        
        RestService.sendAPIKey(userDetails.UserId).then((result)=>{
            NotificationService.success(`The API Key has been successfully sent to the specified email address.`)
        }).catch((error) => {
            console.log(error);
            let msg = error || 'Error while sending API Key';
            NotificationService.error(msg);
        });

    }

    // PF-4931 -- added:
    unblock(){
        const userDetails = this.model.get('updatedUserDetails');

        RestService.unBlockUser(userDetails.UserId).then( () => {
            NotificationService.success(`User unblocked`);
            // refresh UI
            userDetails.BlockedAfterFailedLogins = 'False';
            userDetails.FailedLogins = '0';

            this.model.set({'updatedUserDetails': Object.assign({}, userDetails), 'hasChanges': true}, {silent: true});
            this.makeUpdate();
        }).catch( error => {
            console.log(error);
            NotificationService.error(`Problem unblocking user`);
        });


    }

    render() {
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const userDetails = this.model.get('updatedUserDetails'); 
        const currentUser = listService.accountSettings.UserId;

        if(currentUser === userDetails.UserId){
            $("input[name='IsActive']").attr('disabled',true);
        }
        else{
            $("input[name='IsActive']").removeAttr('disabled');
        }

        // Initialize input values
        this.updateInputs(userDetails);

        this.updateDropdowns(userDetails);

        this.updateRoles(userDetails);

        $('#detailHeading').html('Settings - Dashboard');

        this.delegateEvents();
        this.$el.css('cursor', 'default');

        $("#sendPasswordLink").prop("disabled",this.model.get("userDetails").Status==="3" ? true :false)

        // PF-4931 added:
        $('input[name=unblock]').prop('disabled', userDetails.BlockedAfterFailedLogins === 'False');

        return this;
    }

    refresh(){
        if(this.model.get('hasChanges')){
            
            let simpleModal=new SimpleConfirmModalView({
                model:new Model({subtitle:`User Details - ${this.model.get("userDetails").FirstName} ${this.model.get("userDetails").LastName}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    eventBus.trigger(constants.EV_REFRESH_USER_DETAILS,this.model.get('userDetails').UserId)
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            eventBus.trigger(constants.EV_REFRESH_USER_DETAILS,this.model.get('userDetails').UserId)
        }  
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well_1"]').click();
    }

    goToUsersInfo(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div#well_2 a[data-itemid="usersGroup"]').click();
    }
}

export default UserDetailsView;

